(() => {
  const SECTION_SELECTOR = '.rem-hp-products';
  const SWATCH_SELECTOR = '[data-rem-swatch]';
  const CARD_SELECTOR = '.rem-hp-products__card';
  const IMAGE_SELECTOR = '.rem-hp-products__card-image';
  const LINK_SELECTOR = '[data-rem-card-link]';
  const BADGE_SELECTOR = '[data-rem-card-badge]';
  const BTN_SELECTOR = '[data-rem-card-btn]';
  const BTN_TEXT_SELECTOR = '[data-rem-card-btn-text]';

  class RemProductSwatches {
    constructor(section) {
      this.section = section;
      this.swapTokens = new WeakMap();
    }

    init() {
      this.section.addEventListener('click', this.onClick);
    }

    onClick = (event) => {
      const swatch = event.target.closest(SWATCH_SELECTOR);
      if (!swatch) return;

      const card = swatch.closest(CARD_SELECTOR);
      const image = card?.querySelector(IMAGE_SELECTOR);
      if (!card || !image || swatch.getAttribute('aria-pressed') === 'true') return;

      this.select(card, swatch);
      this.swapImage(image, swatch.dataset);
      this.setAvailability(card, swatch.dataset.variantAvailable !== 'false');
    };

    // Mirrors the Liquid sold-out state (badge, CTA copy, card class) for the chosen color.
    setAvailability(card, isAvailable) {
      card.classList.toggle('is-soldout', !isAvailable);

      const badge = card.querySelector(BADGE_SELECTOR);
      if (badge) badge.hidden = isAvailable;

      const btn = card.querySelector(BTN_SELECTOR);
      if (!btn) return;
      btn.classList.toggle('is-soldout', !isAvailable);
      const { textAvailable, textSoldout } = btn.dataset;
      const text = btn.querySelector(BTN_TEXT_SELECTOR);
      const label = isAvailable ? textAvailable : textSoldout;
      if (text && label) text.textContent = label;
    }

    select(card, active) {
      card.querySelectorAll(SWATCH_SELECTOR).forEach((swatch) => {
        const isActive = swatch === active;
        swatch.classList.toggle('is-selected', isActive);
        swatch.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      const { variantUrl } = active.dataset;
      if (!variantUrl) return;
      card.querySelectorAll(LINK_SELECTOR).forEach((link) => {
        link.href = variantUrl;
      });
    }

    swapImage(image, { imageSrc, imageSrcset, imageAlt }) {
      if (!imageSrc) return;

      const token = (this.swapTokens.get(image) ?? 0) + 1;
      this.swapTokens.set(image, token);

      const apply = () => {
        if (this.swapTokens.get(image) !== token) return;
        if (imageSrcset) image.srcset = imageSrcset;
        image.src = imageSrc;
        image.alt = imageAlt ?? '';
      };

      const preload = new Image();
      preload.sizes = image.sizes;
      if (imageSrcset) preload.srcset = imageSrcset;
      preload.src = imageSrc;

      if (preload.complete) {
        apply();
        return;
      }
      preload.addEventListener('load', apply, { once: true });
      preload.addEventListener('error', apply, { once: true });
    }
  }

  const initRemProductSwatches = (root = document) => {
    root.querySelectorAll(SECTION_SELECTOR).forEach((section) => {
      if (section.dataset.swatchesReady || !section.querySelector(SWATCH_SELECTOR)) return;
      section.dataset.swatchesReady = 'true';
      new RemProductSwatches(section).init();
    });
  };

  initRemProductSwatches();
  document.addEventListener('shopify:section:load', (event) => initRemProductSwatches(event.target));
})();
